import styled from 'styled-components'

export const SearchBarContainer = styled.div`
    margin-bottom: 16px;
`
